export const CONVERTED_POLICY_PRIVILEGES = {
  retail: {
    downloadSelected: 'transactions.convertedPolicies.retail.downloadSelected',
    view: 'transactions.convertedPolicies.retail.view',
    edit: 'transactions.convertedPolicies.retail.edit',
    renew: 'transactions.convertedPolicies.retail.renew',
    downloadDocument: 'transactions.convertedPolicies.retail.downloadDocument',
    share: 'transactions.convertedPolicies.retail.share',
    delete: 'transactions.convertedPolicies.retail.delete'
  },
  corporate: {
    downloadSelected: 'transactions.convertedPolicies.corporate.downloadSelected',
    view: 'transactions.convertedPolicies.corporate.view',
    edit: 'transactions.convertedPolicies.corporate.edit',
    renew: 'transactions.convertedPolicies.corporate.renew',
    downloadDocument: 'transactions.convertedPolicies.corporate.downloadDocument',
    share: 'transactions.convertedPolicies.corporate.share',
    delete: 'transactions.convertedPolicies.corporate.delete'
  }
};

export const convertedPolicyAccessPrivileges = (type) =>
  Object.values(CONVERTED_POLICY_PRIVILEGES[type]);
